import { errorMapper } from './session-errors';
import { SessionWidget } from './session-widget';
import { SessionEvent, SessionEventEmitter } from './session-event-bus';

export class Client {
  constructor(private readonly channel: SessionEventEmitter) {}

  private waitForSessionData(): Promise<void> {
    return new Promise((resolve, reject) => {
      const { sessionWidget } = window;

      // Check if session data is already populated
      const isDataReady = () => sessionWidget?.session && Object.keys(sessionWidget.session).length > 0;

      if (isDataReady()) {
        resolve();
        return;
      }

      let attempts = 0;
      const maxAttempts = 50; // 5 seconds (50 * 100ms)

      const interval = setInterval(() => {
        attempts++;

        if (isDataReady()) {
          clearInterval(interval);
          resolve();
        } else if (attempts >= maxAttempts) {
          clearInterval(interval);
          console.error('[SESSION] Session data population timeout after 5 seconds');
          reject(new Error('Session data population timeout'));
        }
      }, 100);
    });
  }

  async install(sessionWidget: SessionWidget): Promise<void> {
    try {
      this.channel.emit(SessionEvent.SESSION_INSTALLATION_STARTED, { ...sessionWidget.options });

      this.channel.emit(SessionEvent.SESSION_WIDGET_FETCHING_STARTED);
      await sessionWidget.fetch();
      this.channel.emit(SessionEvent.SESSION_WIDGET_FETCHING_FINISHED);

      this.channel.emit(SessionEvent.SESSION_WIDGET_INITIALIZATION_STARTED);
      await sessionWidget.initialize();
      this.channel.emit(SessionEvent.SESSION_WIDGET_INITIALIZATION_FINISHED);

      this.channel.emit(SessionEvent.SESSION_DATA_POPULATION_STARTED);
      await this.waitForSessionData();
      this.channel.emit(SessionEvent.SESSION_DATA_POPULATION_FINISHED);

      this.channel.emit(SessionEvent.SESSION_INSTALLATION_FINISHED);
      return;
    } catch (err) {
      console.error('[SESSION] Installation failed:', err);
      const error = errorMapper(err);
      this.channel.emit(SessionEvent.SESSION_INSTALLATION_FAILED, error);
    } finally {
      await sessionWidget.cleanup();
    }
  }
}
